<template>
    <div class="home pure-g">
        
        <MainMenu class="pure-u-1-6"/>

        <div class="pure-u-5-6">
    
            <div class="menuBarBox">
                <div class="pure-menu pure-menu-horizontal menuBar">
                    <li id="menuCancel" class="pure-menu-item"><router-link class="pure-menu-link" to="/customers" >Abbrechen</router-link></li>
                    <li id="menuSave" class="pure-menu-item"><a v-on:click="saveAndReturn" class="pure-menu-link" >Speichern</a></li>
                    <li id="menuSaveAndNew" class="pure-menu-item"><a v-on:click="saveAndNew" class="pure-menu-link" >Speichern und neu</a></li>    
                </div>
            </div>
    
            <div class="formBox">
                <form class="pure-form pure-form-stacked">
                    <fieldset>
                        <legend>Neuer Kunde</legend>

                        <div class="pure-g">
                            <div class="pure-u-1-1">
                                <label for="account">Name</label>
                                <input id="account" class="pure-u-10-24" type="text" v-model="name">
                            </div>

                            <div class="pure-u-1 pure-u-md-1-3">
                                <label for="comment">Bemerkungen</label>
                                <textarea id="comment" class="pure-u-10-24 comment" v-model="comment">

                                </textarea>
                            </div>
                        </div>
                    </fieldset>
                </form>
            </div>
        </div>
    </div>
</template>


<script>
import MainMenu from '@/components/MainMenu.vue'
import axios from "axios"
import router from '@/router.js'
import { getJwt } from '@/utils/auth.js'
import { toastInfo, toastError } from '@/utils/toast.js'
import { getApiUrl } from '@/utils/api.js'


export default {
    name: "newCustomerView",
    components: {
        MainMenu
    },
    data: function() {
        return {
            name: null,
            comment: null
        }
    },
    mounted: function() {

    },
    methods: {

        save: function(doReturn) {

            axios({ 
                method: 'POST', 
                'url': getApiUrl() + '/v0/customers/',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + getJwt()
                },
                data: {
                    name: this.name,
                    comment: this.comment
                }
            })
            .then(
                result => {
                    toastInfo('Ein neuer Kunde wurde angelegt.')

                    if (doReturn) {
                        router.push({ name: 'customerView' })
                    } else {
                        this.clear()
                    }
                },
                error => {
                    toastError(error.response.data.message)
                }
            )
        },
        saveAndReturn: function() {

            this.save(true)
        },
        saveAndNew: function() {

            this.save(false)
        },
        clear: function() {

            this.name = null
            this.comment = null
        }
    }
};
</script>


<style>
</style>
